export default __webpack_public_path__ + "static/media/SWT0090.34I-21568_-16376_0.0c37f710.jpg";